// Traduções específicas para a página "Buscamos para você" - Português (Brasil)
export const weSearchForYouPt = {
  hero: {
    title: 'Buscamos Seu Carro',
    description:
      'Não encontrou o carro que procura? Nós buscamos para você e avisamos quando tivermos opções que atendam às suas necessidades.',
  },
  form: {
    criteriaTitle: 'Critérios de Busca',
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    phone: 'Telefone',
    brand: 'Marca',
    brandPlaceholder: 'Selecione uma marca',
    model: 'Modelo',
    modelPlaceholder: 'Selecione um modelo',
    yearFrom: 'Ano mínimo',
    yearTo: 'Ano máximo',
    yearFromPlaceholder: 'Ex: 2018',
    yearToPlaceholder: 'Ex: 2023',
    maxMileage: 'Quilometragem máxima',
    maxMileagePlaceholder: 'Ex: 50000',
    maxOwners: 'Máximo de donos',
    maxOwnersPlaceholder: 'Ex: 2',
    budget: 'Orçamento',
    budgetPlaceholder: 'Ex: 80.000', // BR: "15.000.000" (pesos chilenos) → valor em reais
    message: 'Detalhes adicionais',
    messagePlaceholder:
      'Conte mais detalhes sobre o que você procura...',
    submit: 'Solicitar Busca',
  },
  info: {
    howItWorksTitle: 'Como Funciona Nosso Serviço?',
    processTitle: 'Nosso processo',
    processList: {
      step1: 'Você envia sua solicitação com os critérios específicos',
      step2: 'Recebemos e registramos sua solicitação',
      step3: 'Iniciamos a busca ativa no nosso mercado',
      step4: 'Entramos em contato quando encontrarmos opções',
      step5: 'Você agenda a visita e a avaliação do veículo',
      step6: 'Você fecha a compra se gostar',
    },
    advantagesTitle: 'Vantagens do serviço',
    advantagesList: {
      item1: 'Busca personalizada de acordo com seus critérios',
      item2: 'Acesso a veículos não anunciados',
      item3: 'Avaliação prévia de qualidade',
      item4: 'Negociação profissional',
      item5: 'Sem custo adicional pelo serviço',
      item6: 'Consultoria especializada',
    },
    directContactTitle: 'Contato Direto',
    emailLabel: 'E-mail',
    phoneLabel: 'Telefone',
    tipTitle: 'Dica importante',
    tipText:
      'Quanto mais específicos forem seus critérios, melhor conseguiremos encontrar o veículo ideal para você. Fique à vontade para incluir detalhes adicionais na mensagem.',
  },
  successMessage:
    'Solicitação de busca enviada com sucesso! Entraremos em contato em breve quando tivermos opções que atendam aos seus critérios.',
  embed: {
    infoTitle: 'Como funciona?',
    steps: [
      { title: 'Conte o que você procura', desc: 'Preencha o formulário com suas preferências e orçamento.' },
      { title: 'Buscamos para você', desc: 'Nossa equipe busca em toda a nossa rede de fornecedores.' },
      { title: 'Mostramos as opções', desc: 'Apresentamos as melhores alternativas encontradas.' },
      { title: 'Compra segura', desc: 'Cuidamos da compra com vistoria mecânica incluída.' },
    ],
    benefitsTitle: 'Benefícios',
    benefits: ['Busca personalizada', 'Acesso à rede de fornecedores', 'Vistoria mecânica incluída', 'Garantia de satisfação'],
  },
};
